import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Input, Tooltip, Modal } from 'components';
import { CleanIcon, EyeBlackIcon } from 'assets/icons';
import moment from 'moment';
import { QuoteService } from 'services';
import { Constants, Print } from 'utils';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	since: '',
	until: '',
	service: '',
	search: ''
}

class Quotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha',
			'Tipo de Cirugía',
			'Médico Tratante',
			'Paciente',
			'Solicitud',
			'Acción'
		],
		form: INITIAL_STATE,
		visible_responses: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cotizaciones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await QuoteService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	view = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await QuoteService.admin.download({
			quote_id: item?.id
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	viewResponses = async (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_responses: true,
			item
		});
	}

	onCloseResponses = () => {
		this.setState({
			visible_responses: false,
			item: null
		});
	}
	
	render() {
		const { visible_responses } = this.state;

		return (
			<div id="admin-quotes">
				<Modal
		          className="modal-view-quote"
		          visible={ visible_responses }
		          withoutClose={ true }
		          onClose={ () => this.onCloseResponses() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onCloseResponses() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por médico tratante"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4">
						<Input
							value={ this.state.form.service }
							name="service"
							label="Tipo de Cirugía"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4"></div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Desde"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'since'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.since }
						/>
					</div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Hasta"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'until'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.until }
						/>
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Historial de Cotización" data={ this.state.data.length } rightAlign={[ 5 ]} header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD-MM-YYYY') }</td>
								<td>{ i.service?.name }</td>
								<td>{ i.user?.name }</td>
								<td>{ i.patient }</td>
								<td>
									<a href="#" onClick={ (e: any) => this.view(e,i) }>Ver</a>
								</td>
								<td className="text-right">
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.viewResponses(e,i) }>
											<img src={ EyeBlackIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Quotes);